import { COMMON_LANGUAGES } from '@sdbn/common';
import packageInfo from '../../package.json';

export class DefaultSettings {

  public static get(tmcBaseUrl: string, tmcClientUrl: string) {
    return {

      tmcBaseUrl: tmcBaseUrl,
      tmcclientUrl: tmcClientUrl,
      tmcClientUrl: tmcClientUrl,

      VERSION: packageInfo.version,

      enableLogging: true,
      simulatorAvailable: true,
      scanNumberplateAvailable: true,

      autoreload: true,
      // Enablement nur der Wizardrouten. Alle anderen Routen werden exkludiert, wenn dieser Parameter auf true steht
      onlyWizardsAvailable: false,

      // Activate angular Router to write routing infos to console
      enableRouteTracing: false,

      // Security settings
      authenticationStrategy: 'tmc', // authentication strategy. Allowed: tmc, oauth2

      // OAuth2 basic settings
      responseType: 'code',
      redirectUri: tmcClientUrl + '/login/process',
      oAuth2SilentRefresh: true, // must be false for AzureAD. Leads to invalid token refresh requests
      oAuth2SilentRefreshTimeout: 0.75, // If this X% of the token's life time is over, the refresh event is triggered
      oAuth2SkipIssuerCheck: false, // must be true for AzureAD
      disableAtHashCheck: true,  // Azure AD don't have the field at_hash, so disable the check

      // Timer constants
      notificationPollingInterval: 30000,

      // Sprachauswahl
      // Based on: http://fi-css.lip.is/
      // see https://docs.angularactivity.com/angular-7-fi-css for installation details.
      languageOptions: [
        COMMON_LANGUAGES.find(l => l.key === 'de'),
        COMMON_LANGUAGES.find(l => l.key === 'en'),
        COMMON_LANGUAGES.find(l => l.key === 'fr'),
        COMMON_LANGUAGES.find(l => l.key === 'it'),
        COMMON_LANGUAGES.find(l => l.key === 'pl'),
        COMMON_LANGUAGES.find(l => l.key === 'da')
      ],
      messagingLanguages: [
        'de', 'en', 'fr', 'es', 'it', 'cs', 'hu', 'sk', 'pl', 'ru', 'bg', 'ro', 'tr', 'lt', 'el', 'da', 'nl','sr','hi','ar'
      ],
      registrationTerminalLanguageOptions: [
        COMMON_LANGUAGES.find(l => l.key === 'bg'),
        COMMON_LANGUAGES.find(l => l.key === 'cs'),
        COMMON_LANGUAGES.find(l => l.key === 'de'),
        COMMON_LANGUAGES.find(l => l.key === 'en'),
        COMMON_LANGUAGES.find(l => l.key === 'es'),
        COMMON_LANGUAGES.find(l => l.key === 'fr'),
        COMMON_LANGUAGES.find(l => l.key === 'it'),
        COMMON_LANGUAGES.find(l => l.key === 'lt'),
        COMMON_LANGUAGES.find(l => l.key === 'hu'),
        COMMON_LANGUAGES.find(l => l.key === 'pl'),
        COMMON_LANGUAGES.find(l => l.key === 'ro'),
        COMMON_LANGUAGES.find(l => l.key === 'ru'),
        COMMON_LANGUAGES.find(l => l.key === 'sk'),
        COMMON_LANGUAGES.find(l => l.key === 'tr'),
        COMMON_LANGUAGES.find(l => l.key === 'el'),
        COMMON_LANGUAGES.find(l => l.key === 'da'),
        COMMON_LANGUAGES.find(l => l.key === 'nl'),
        COMMON_LANGUAGES.find(l => l.key === 'sr'),
        COMMON_LANGUAGES.find(l => l.key === 'hi'),
        COMMON_LANGUAGES.find(l => l.key === 'ar')
      ],

      documentScanResultuion: 'hd',
      summaryTimerSeconds: 60,

      globalConnectAppleAppStoreUrl: 'https://apps.apple.com/de/app/sdbn-global-connect/id1451724887',
      globalConnectGooglePlayStoreUrl: 'https://play.google.com/store/apps/details?id=de.sdbnsolutions.globalconnect',

      // Endpoint configuration
      pingEndpoint: tmcBaseUrl + '/ping',
      loginEndpoint: tmcBaseUrl + '/client/token',
      accountEndpoint: tmcBaseUrl + '/client/account',
      accountInfoEndpoint: tmcBaseUrl + '/client/account/info',
      userProfileEndpoint: tmcBaseUrl + '/client/user-profile',
      clientParameterEndpoint: tmcBaseUrl + '/client/client-parameters',
      dictionaryEndpoint: tmcBaseUrl + '/client/dictionary',
      resourceEndpoint: tmcBaseUrl + '/client/resource',
      clientConfiguration: tmcBaseUrl + '/client-configuration',
      moduleGroupEndpoint: tmcBaseUrl + '/client/modulegroups',
      dashboardEndpoint: tmcBaseUrl + '/client/dashboards',
      accessInformationEndpoint: tmcBaseUrl + '/client/accesstarget',
      deviceParameterEndpoint: tmcBaseUrl + '/client/deviceproperty',

      simulatorEndpoint: tmcBaseUrl + '/client/control/simulator',
      attachDetachEndpoint: tmcBaseUrl + '/client/control/attach-detach',
      sacClientEndpoint: tmcBaseUrl + '/client/control/sac-client',
      actionTabletEndpoint: tmcBaseUrl + '/client/control/action-tablet',
      cepTabletEndpoint: tmcBaseUrl + '/client/control/cep-tablet',
      visitOverviewEndpoint: tmcBaseUrl + '/client/control/visitsoverview',
      transportOverviewEndpoint: tmcBaseUrl + '/client/control/transportoverview',
      transportRegistrationEndpoint: tmcBaseUrl + '/client/control/transport/registration',
      registerEntranceEndpoint: tmcBaseUrl + '/client/control/transport/register/entrance',
      registerLeaveEndpoint: tmcBaseUrl + '/client/control/transport/register/leave',
      changeTransportRoutingEndpoint: tmcBaseUrl + '/client/control/change/transportrouting',
      stationSelectionEndpoint: tmcBaseUrl + '/client/control/stationselection',
      supplementaryEquipmentHandoutEndpoint: tmcBaseUrl + '/client/control/supplementaryequipment/handout',
      supplementaryEquipmentTakeBackEndpoint: tmcBaseUrl + '/client/control/supplementaryequipment/takeback',
      visitSupplementaryEquipmentHandoutEndpoint: tmcBaseUrl + '/client/visit/control/visit/supplementaryequipment/handout',
      visitorSupplementaryEquipmentTakeBackEndpoint: tmcBaseUrl + '/client/visit/control/supplementaryequipment/takeback',
      visitReportingEndpoint: tmcBaseUrl + '/client/visit/control/reporting',
      visitHistoryEndpoint: tmcBaseUrl + '/client/visit/visit-history',
      yardSelectionEndpoint: tmcBaseUrl + '/client/control/yardselection',
      transportDetailsEndpoint: tmcBaseUrl + '/client/control/transport/details',
      transportDocumentUploadEndpoint: tmcBaseUrl + '/client/control/transport/details/document/upload',
      personalVisitEndpoint: tmcBaseUrl + '/client/control/personalvisit',
      truckEndpoint: tmcBaseUrl + '/client/control/truck',
      deleteTransportEndpoint: tmcBaseUrl + '/client/control/transport/delete',
      pauseTransportEndpoint: tmcBaseUrl + '/client/control/transport/pause',
      transportActivationEndpoint: tmcBaseUrl + '/client/control/transport/activation',
      changeTransportEndpoint: tmcBaseUrl + '/client/control/change/transport',
      reportingEndpoint: tmcBaseUrl + '/client/control/reporting',
      weighingEndpoint: tmcBaseUrl + '/client/control/weighing',
      taskEndpoint: tmcBaseUrl + '/client/control/tasks',
      linkTransportsEndpoint: tmcBaseUrl + '/client/control/linktransports',
      timeframeUsageEndpoint: tmcBaseUrl + '/client/control/timeframe-usage',
      documentEndpoint: tmcBaseUrl + '/client/document',
      transportIssuesEndpoint: tmcBaseUrl + '/client/control/transport/issues',
      transportUmbrueckungEndpoint: tmcBaseUrl + '/client/control/umbrueckung',
      autocompletionEndpoint: tmcBaseUrl + '/client/control/autocompletion',
      cleanTransportEndpoint: tmcBaseUrl + '/client/control/transport/clean',
      yardMapEndpoint: tmcBaseUrl + '/client/control/yardmap',
      movementOrderEndpoint: tmcBaseUrl + '/client/control/movement-orders',
      scanNumberplateEndpoint: tmcBaseUrl + '/client/control/scan-numberplate',
      notificationEndpoint: tmcBaseUrl + '/client/notification',

      transportProfilesEndpoint: tmcBaseUrl + '/client/admin/transportprofiles',
      stationGroupEndpoint: tmcBaseUrl + '/client/admin/stationgroups',
      userGroupsAdminEndpoint: tmcBaseUrl + '/client/admin/usergroups',
      usersAdminEndpoint: tmcBaseUrl + '/client/admin/users',
      stationsAdminEndpoint: tmcBaseUrl + '/client/admin/stations',
      supplementaryEquipmentAdminEndpoint: tmcBaseUrl + '/client/admin/supplementaryequipment',
      clientParameterAdminEndpoint: tmcBaseUrl + '/client/admin/client-parameter',
      smartphoneAdminEndpoint: tmcBaseUrl + '/client/admin/smartphone',
      pagerAdminEndpoint: tmcBaseUrl + '/client/admin/pager',
      rfidCardAdminEndpoint: tmcBaseUrl + '/client/admin/rfidcard',
      rfidCardProtocolAdminEndpoint: tmcBaseUrl + '/client/admin/rfidcardprotocol',
      transportOptionsEndpoint: tmcBaseUrl + '/client/admin/transportoptions',
      routingRulesEndpoint: tmcBaseUrl + '/client/admin/routingrules',
      customFilterEndpoint: tmcBaseUrl + '/client/admin/custom-filter',
      filterEndpoint: tmcBaseUrl + '/client/admin/filter',
      taskAdmininEndpoint: tmcBaseUrl + '/client/admin/task',
      issueTypeAdmininEndpoint: tmcBaseUrl + '/client/admin/issue-type',
      yardAdminEndpoint: tmcBaseUrl + '/client/admin/yard',
      yardMapAdminEndpoint: tmcBaseUrl + '/client/admin/yardmap',
      dataProtectionAdminEndpoint: tmcBaseUrl + '/client/admin/dataprotection',
      automationRuleAdminEndpoint: tmcBaseUrl + '/client/admin/automation/rule',
      processingStatusModelAdminEndpoint: tmcBaseUrl + '/client/admin/processing-status-model',
      documentTemplateAdminEndpoint: tmcBaseUrl + '/client/admin/document-template',
      transportMessageAdminEndpoint: tmcBaseUrl + '/client/admin/message',
      blacklistAdminEndpoint: tmcBaseUrl + '/client/admin/blacklist',
      cleanupAdminEndpoint: tmcBaseUrl + '/client/admin/cleanup',
      dashboardAdminEndpoint: tmcBaseUrl + '/client/admin/dashboard',
      reportingGroupAdminEndpoint: tmcBaseUrl + '/client/admin/reporting-group',
      moduleAdminEndpoint: tmcBaseUrl + '/client/admin/modules',
      routingLogInspectorAdminEndpoint: tmcBaseUrl + '/client/admin/routing-log-inspector',
      timeSyncDefinitionEndpoint: tmcBaseUrl + '/client/admin/time-symc-definition',
      transportCreationProfileAdminEndpoint: tmcBaseUrl + '/client/admin/transport-creation-profile',
      yardSimulatorAdminEntpoint: tmcBaseUrl + '/client/admin/yard-simulator',
      secureKeysAdminEntpoint: tmcBaseUrl + '/client/admin/secure-keys',
      equipment: tmcBaseUrl + '/client/admin/equipment',

      sendMessageEndpoint: tmcBaseUrl + '/client/control/send-message',

      visitReservationEndpoint: tmcBaseUrl + '/client/visitreservation',
      visitorRoleAdminEndpoint: tmcBaseUrl + '/client/admin/visitor-role',

      displaysEndpoint: tmcBaseUrl + '/client/displays',

      activityLogEndpoint: tmcBaseUrl + '/client/activitylog',

      appClientURLAdminEndpoint: tmcBaseUrl + '/client/admin/appclienturl',
      appClientURLEndpoint: tmcBaseUrl + '/client/appclienturl',

      // Visit
      visitorfilterAdminiEndpoint: tmcBaseUrl + '/client/admin/visitor-filter-administration',

      // Registration Terminal
      caseConnectMaxRetries: 10,
      registrationCodeEndpoint: tmcBaseUrl + '/terminal/registration/code',
      registrationNotifyEndpoint: tmcBaseUrl + '/terminal/registration/notify',
      connectMobileEndpoint: tmcBaseUrl + '/terminal/connectMobile',
      instructionsEndpoint: tmcBaseUrl + '/terminal/instructions',
      registrationTransportWithBarcodeEndpoint: tmcBaseUrl + '/terminal/registration/transport/barcode',
      registrationFinishTransportEndpoint: tmcBaseUrl + '/terminal/registration/finish/transport',
      registrationFinishTruckEndpoint: tmcBaseUrl + '/terminal/registration/finish/truck',
      registrationUploadEndpoint: tmcBaseUrl + '/terminal/registration/upload',
      registrationVisitorFinishEndpoint: tmcBaseUrl + '/terminal/registration/visitor/finish',
      registrationVisitorDownloadRegistrationEndpoint: tmcBaseUrl + '/terminal/registration/visitor/download-registrationcard',
      registrationVisitorCodeEndpoint: tmcBaseUrl + '/terminal/registration/visitor/code',
      registrationVisitorPreparationsEndpoint: tmcBaseUrl + '/terminal/registration/visitor/preparations',
      registrationVisitorFindVisitorRolesEndpoint: tmcBaseUrl + '/terminal/registration/visitor/find-visitor-roles',
      registrationVisitorWithBarcodeEndpoint: tmcBaseUrl + '/terminal/registration/visitor/barcode',
      registrationVisitorLeaveEndpoint: tmcBaseUrl + '/terminal/registration/visitor/leave',
      registrationGetAllAdditionalVisitorEndpoint: tmcBaseUrl + '/terminal/registration/visitor/get-additional-visitors',
      registrationInviteAdditionalVisitorEndpoint: tmcBaseUrl + '/terminal/registration/visitor/invite-visitor',
      registrationVisitorInstructionsFinishEndpoint: tmcBaseUrl + '/terminal/registration/visitor/save-instructions-result',

      inactivitySensitivitySeconds: 10,
      inactivityTimoutSeconds: 50,
      inactivityPostponeCounterSeconds: 60,


      // ERP
      erpCatalogEndpoint: tmcBaseUrl + '/client/erp-article/catalog',
      erpArticleTypeEndpoint: tmcBaseUrl + '/client/erp-article/article-type',
      erpBasicArticleEndpoint: tmcBaseUrl + '/client/erp-article/basicarticle',
      erpArticleEndpoint: tmcBaseUrl + '/client/erp-article/article',
      erpProjectEndpoint: tmcBaseUrl + '/client/erp-project/project'

    };
  }
}
